import { render, staticRenderFns } from "./RegistrationInfoButton.vue?vue&type=template&id=644b8dd4"
import script from "./RegistrationInfoButton.vue?vue&type=script&lang=ts"
export * from "./RegistrationInfoButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports